import { Box, Avatar, Text, VStack, HStack, Badge } from "@chakra-ui/react";

const ProfileCard = ({ name, email, profileImage, status }) => {
  return (
    <Box
      bg="white"
      p={4}
      borderRadius="md"
      boxShadow="sm"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      w="100%"
    >
      <HStack spacing={4}>
        <Avatar size="md" name={name} src={profileImage} />
        <VStack align="start" spacing={0}>
          <Text fontWeight="bold" fontSize="md">
            {name}
          </Text>
          <Text fontSize="sm" color="gray.500">
            {email}
          </Text>
        </VStack>
      </HStack>

      {status && (
        <Badge colorScheme="green" px={3} py={1} borderRadius="full">
          {status}
        </Badge>
      )}
    </Box>
  );
};

export default ProfileCard;
